(function () {
  if (window.__founderVideoVwoBound) return;
  window.__founderVideoVwoBound = true;

  function playFounderVideo(root) {
    var media = root.querySelector('[data-founder-media]');
    var template = root.querySelector('[data-founder-video-template]');
    if (!media || !template || media.classList.contains('is-playing')) return;
    media.classList.add('is-playing');
    media.appendChild(template.content.cloneNode(true));
    var video = media.querySelector('video');
    if (video && typeof video.play === 'function') {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var playBtn = event.target.closest('[data-founder-play]');
      if (!playBtn) return;
      event.preventDefault();
      var root = playBtn.closest('.founder-video-vwo');
      if (root) playFounderVideo(root);
    },
    true
  );

  function showForPreview() {
    try {
      if (new URLSearchParams(window.location.search).get('founder_video') !== '1') return;
    } catch (e) {
      return;
    }
    document.querySelectorAll('.shopify-section--founder-video-vwo, .founder-video-vwo').forEach(function (el) {
      el.style.setProperty('display', 'block', 'important');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showForPreview);
  } else {
    showForPreview();
  }
})();
